module.exports = __WEBPACK_EXTERNAL_MODULE_46__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 46
// module chunks = 0